// Verifikat table styling — mirrors /Bookkeeping/steps/PreviewStep.jsx so
// the expense booking/settlement modals read the same as manual bokföring:
// compact flex table, monospace amounts, green debet / blue kredit, em-dash
// empty cells, balance indicator pill.

export const verifikatTableCss = `
  .bk-compact-table {
    background: white; border-radius: 8px; overflow: hidden;
    border: 1px solid #e2e8f0;
  }
  .bk-compact-table-header {
    background: #f8fafc; border-bottom: 1px solid #e2e8f0;
    padding: 0.75rem 1rem; font-size: 0.75rem;
    font-weight: 600; text-transform: uppercase; letter-spacing: 0.025em;
    color: #64748b;
  }
  .bk-compact-table-row {
    padding: 0.75rem 1rem; border-bottom: 1px solid #f1f5f9;
    font-size: 0.875rem; transition: background-color 0.15s ease;
  }
  .bk-compact-table-row:hover { background: #f8fafc; }
  .bk-compact-table-row:last-child { border-bottom: none; }
  .bk-compact-table-footer {
    background: #f1f5f9; padding: 0.75rem 1rem;
    font-weight: 600; font-size: 0.875rem;
    border-top: 2px solid #e2e8f0;
  }
  .bk-amount-cell {
    font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
    font-size: 0.875rem;
  }
  .bk-balance-indicator {
    display: inline-flex; align-items: center; gap: 0.5rem;
    padding: 0.5rem 1rem; border-radius: 8px;
    font-weight: 600; font-size: 0.875rem;
  }
  .bk-balance-good {
    background: rgba(104, 227, 101, 0.15);
    color: #198754;
    border: 1px solid rgba(104, 227, 101, 0.3);
  }
  .bk-balance-bad {
    background: rgba(247, 43, 80, 0.08);
    color: #dc3545;
    border: 1px solid rgba(247, 43, 80, 0.2);
  }

  .bk-row-delete {
    width: 28px; height: 28px; border-radius: 6px;
    background: transparent; border: 1px solid transparent;
    color: #94a3b8; cursor: pointer;
    display: flex; align-items: center; justify-content: center;
    transition: all 0.15s ease;
    padding: 0;
  }
  .bk-compact-table-row:hover .bk-row-delete { color: #64748b; }
  .bk-row-delete:hover {
    background: #fee2e2; border-color: #fecaca; color: #dc2626;
  }
`;
